"use client";

import { c as _c } from "react/compiler-runtime";
import { CenterAligned, Modal, ModalBody, Spinner } from "@opensea/ui-kit";
import { useSnapshot } from "valtio";
import { MfaHandlerActions, MfaHandlerState } from "../../stores/mfaHandlerStore";
import { useOnMfaRequired } from "../useOnMfaRequired";
import { MfaChallenge } from "./MfaChallenge";
import { MfaEnrollment } from "./MfaEnrollment";
const MfaRequired = () => {
  const $ = _c(5);
  const {
    needsEnrollment,
    needsAuthentication
  } = useSnapshot(MfaHandlerState);
  let t0;
  if ($[0] !== needsAuthentication || $[1] !== needsEnrollment) {
    t0 = () => {
      if (needsEnrollment) {
        return <MfaEnrollment />;
      }
      if (needsAuthentication) {
        return <MfaChallenge />;
      }
      return <CenterAligned className="h-[400px]"><Spinner /></CenterAligned>;
    };
    $[0] = needsAuthentication;
    $[1] = needsEnrollment;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const renderContent = t0;
  let t1;
  if ($[3] !== renderContent) {
    t1 = <ModalBody className="text-center">{renderContent()}</ModalBody>;
    $[3] = renderContent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export const MfaHandler = () => {
  const $ = _c(3);
  const {
    needsAuthentication,
    needsEnrollment
  } = useSnapshot(MfaHandlerState);
  useOnMfaRequired(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MfaRequired />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = needsAuthentication || needsEnrollment;
  let t2;
  if ($[1] !== t1) {
    t2 = <Modal className="md:rounded-xl" content={t0} onOpenChange={_temp2} open={t1} size="sm" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(mfaMethods, onComplete) {
  MfaHandlerActions.startMfaChallenge(mfaMethods, onComplete);
}
function _temp2(open) {
  if (!open) {
    MfaHandlerActions.cancelMfaChallenge();
  }
}